__turbopack_context__.v({
  "container": "IndustryInsightsCard-module-scss-module__0V-0QW__container",
  "desc": "IndustryInsightsCard-module-scss-module__0V-0QW__desc",
  "heading": "IndustryInsightsCard-module-scss-module__0V-0QW__heading",
  "root": "IndustryInsightsCard-module-scss-module__0V-0QW__root",
});
